// material-ui
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// project import
import { useUserInfo } from 'hooks/useUserInfo';

// assets
import { AuditOutlined } from '@ant-design/icons';

// react-router
import { useNavigate } from 'react-router-dom';

// ==============================|| HEADER CONTENT - COMPLIANCE BUTTON ||============================== //

export default function ComplianceButton() {
  const { isAdmin, isCompliance } = useUserInfo();
  const navigate = useNavigate();

  // Compliance team (Compliance role) and admins only. Both flags key off the signed-in user, so
  // this is not affected by impersonation.
  if (!isAdmin && !isCompliance) {
    return null;
  }

  return (
    <Tooltip title="Compliance">
      <IconButton color="secondary" onClick={() => navigate('/compliance')} sx={{ color: 'text.primary' }}>
        <AuditOutlined />
      </IconButton>
    </Tooltip>
  );
}
